import { render, staticRenderFns } from "./ComponentBuilderDataWithVariation.vue?vue&type=template&id=a0445108&"
import script from "./ComponentBuilderDataWithVariation.vue?vue&type=script&lang=js&"
export * from "./ComponentBuilderDataWithVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports